<template>
  <v-card color="kbWhite" class="main-card">
    <v-card-text>
      <div style="display: flex; justify-content: space-between">
        <div>
          <div class="main-card__name">
            {{info.name}}
          </div>

          <div class="main-card__value">
            {{info.value}}
          </div>
        </div>

        <div>
          <v-avatar :color="info.type === 'increase' ? 'green' : 'red'">
            <v-icon color="white">
              {{info.type === 'increase' ? 'mdi-trending-up' : 'mdi-trending-down'}}
            </v-icon>
          </v-avatar>
        </div>
      </div>

      <div style="display: flex; justify-content: space-between">
        <span class="font-weight-bold"
              :class="[info.type === 'increase' ? 'green--text' : 'red--text']">
          {{info.percetage}}
        </span>

        <span>
          {{info.date}}
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['info']
}
</script>

<style>
  .main-card {
    border-radius: 16px !important;
    width: 100% !important;
  }

  .main-card__name {
    font-size: 12px;
    text-transform: uppercase;
  }

  .main-card__value {
    font-size: 34px;
  }
</style>
